import React from "react";
import { ActivityIndicator, Image } from "react-native";
import { useTheme } from "../AHTheme/AHTheme";

export type AHFileIconType =
  | "PPT"
  | "PPTX"
  | "DOC"
  | "DOCX"
  | "PDF"
  | "XLS"
  | "XLSX"
  | "integration"
  | "loading"
  | "IMG";

export function AHFileIcon(props: {
  filetype: AHFileIconType | null;
  size?: number;
}) {
  const theme = useTheme();
  const size = props.size ?? 22;
  switch (props.filetype) {
    case "loading":
      return <ActivityIndicator size="small" color={theme.primary} />;
    case "integration":
      return (
        <Image
          source={require("./images/link.png")}
          style={{ height: size, width: size }}
        />
      );
    case "PPT":
    case "PPTX":
      return (
        <Image
          source={require("./images/powerpoint.png")}
          style={{ height: size, width: size }}
        />
      );
    case "DOC":
    case "DOCX":
      return (
        <Image
          source={require("./images/text.png")}
          style={{ height: size, width: size }}
        />
      );
    case "PDF":
      return (
        <Image
          source={require("./images/pdf.png")}
          style={{ height: size, width: size }}
        />
      );
    case "XLS":
    case "XLSX":
      return (
        <Image
          source={require("./images/excel.png")}
          style={{ height: size, width: size }}
        />
      );
    case "IMG":
      return (
        <Image
          source={require("./images/img.png")}
          style={{ height: size, width: size }}
        />
      );
  }
  return (
    <Image
      source={require("./images/pdf.png")}
      style={{ height: size, width: size }}
    />
  );
}
